// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@sc/Overrides/Widgets/Brand/BrandList";
import ArrowUp from "@sc/XDL/Icons/ArrowUp";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

listStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 32px;
        margin-top: 32px;
    `,
};

listStyles.brandAlphabetSections = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 12px;
        margin-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

listStyles.brandLetter = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
        text-transform: uppercase;
    `,
};

listStyles.brandItemsWrapper = {
    gap: 8,
    css: css`
        margin: 0;
        max-width: 100%;
    `,
};

listStyles.brandItem = {
    width: [12, 12, 6, 3, 3],
    css: css`
        padding: 6px;
    `,
};

listStyles.brandLink = {
    color: "primary.main",
    typographyProps: {
        size: 16,
        css: css`
            margin: 0;
            line-height: 17px;
        `,
    },
};

listStyles.backToTopLink = {
    typographyProps: {
        size: 12,
        css: css`
            line-height: 13px;
        `,
    },
};

listStyles.backToTopIcon = {
    color: "primary.main",
    css: css`
        margin-left: 8px;
        opacity: 0.66;
    `,
    src: ArrowUp,
    height: 12,
    width: 9,
};
